// extracted by mini-css-extract-plugin
export default {"notStarted":"webpack-containers-Review-Home-StageNotStarted-module__notStarted"};